import React, { useRef, useState } from "react";
import "./TrustSection.css";

const TrustSection = () => {
  const sliderRef = useRef(null);
  const [activeDot, setActiveDot] = useState(0);

  const handleScroll = () => {
    const scrollLeft = sliderRef.current.scrollLeft;
    const width = sliderRef.current.offsetWidth;
    const index = Math.round(scrollLeft / width);
    setActiveDot(index);
  };

  return (
    <section className="trust-informational-wrapper">
      <div
        className="info-grid"
        ref={sliderRef}
        onScroll={handleScroll}
      >

        {/* Free Shipping */}
        <div className="info-item">
          <div className="info-icon-wrapper">
            <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
              <path d="m3.3 7 8.7 5 8.7-5" />
              <path d="M12 22V12" />
            </svg>
          </div>
          <h3>Free Shipping</h3>
          <p>Enjoy free shipping on all apparel across PAN India. Accessories excluded.</p>
        </div>

        {/* COD
        <div className="info-item">
          <div className="info-icon-wrapper">
            <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
              <path d="M6 15h.01" />
              <path d="M10 15h.01" />
            </svg>
          </div>
          <h3>COD Available</h3>
          <p>Cash on Delivery is available for most serviceable locations.</p>
        </div> */}

        {/* Premium Quality */}
        <div className="info-item">
          <div className="info-icon-wrapper">
            <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <path d="M12 2l2.4 4.9L20 7.8l-4 3.9.9 5.6L12 15.9 7.1 17.3l.9-5.6-4-3.9 5.6-.9L12 2z" />
            </svg>
          </div>
          <h3>Premium Quality</h3>
          <p>
            Crafted with premium fabrics and attention to detail for long-lasting comfort and style.
          </p>
        </div>

        {/* Secure Payment */}
        <div className="info-item">
          <div className="info-icon-wrapper">
            <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <rect x="3" y="11" width="18" height="11" rx="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <h3>Secure Payments</h3>
          <p>
            100% secure payments powered by Razorpay. We accept UPI, cards,
            net banking, and wallets.
          </p>
        </div>


      </div>

      {/* Mobile Dots */}
      <div className="mobile-dots">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={`dot ${activeDot === i ? "active" : ""}`}
          />
        ))}
      </div>
    </section>
  );
};

export default TrustSection;
